import React from "react";
import { translations } from "../translations";

const Instructor = (props) => {
  const { wing_type, member } = props;

  if (!member.instructor) {
    return null;
  }

  return member.instructor &&
    Object.keys(member.instructor).length > 0 &&
    member.instructor[wing_type] &&
    member.expiry_dates.courses[wing_type] ? (
    <div className="member__instructor">
      {member.instructor[wing_type]}
      {member.expiry_dates && (
        <span className="member__instructor_date">
          {`${translations[window?.memberSearchConfig?.lang || 'en'].valid_until} ${member.expiry_dates.courses[wing_type]}`}
        </span>
      )}
    </div>
  ) : (
    ""
  );
};

export default Instructor;
